module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Italic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Italic-webfont.eot
// module id = 684
// module chunks = 0